export default __webpack_public_path__ + "static/media/Shahariar Rijon Resume.32add6a3.pdf";